import React from "react";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import pdf from "views/profile/img/profile/pdf.png";
import close from "views/profile/img/profile/close.png";
import resumeview from "views/job-details/img/resumeview.png";
import pdfview from "views/job-details/img/pdfview.png";
import { Maximize } from "react-feather";
import checksuccess from "views/job-details/img/checksuccess.png";
import checkview from "views/job-details/img/checktick.png";
import { connect } from "react-redux";
import Resume from "views/profile/profile/components/Resume";
import Contact from "views/profile/profile/components/Contact";
import Education from "views/profile/profile/components/Education";
import Experience from "views/profile/profile/components/Experience";
import Miscellaneous from "views/profile/profile/components/Miscellaneous";
import {
  getBasicAction,
  getContactAction,
  getEducationAction,
  getEmployeeAction,
  getlanguageAction,
} from "store/userWalkthrough";
import { jobApplyAction, saveAppliedJobsHc } from "store/SingleJob";
import { setLoader } from "store/Auth";
import { geResumeHC } from "store/Profile";
class JobDetailsApplyPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isJobDetails: 0, IsJobApllied: false, isSubmit: true };
  }

  checkSubmit(e) {
    this.setState({ isSubmit: e });
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   console.log(prevState);
  //   if (this.props.Auth.HCID) {
  //     if (this.state.isJobDetails !== prevState.isJobDetails) {
  //       if (this.state.isJobDetails == 1) {
  //         let ResumeResponse = this.props.geResumeHC(this.props.Auth.HCID);
  //         this.props.getBasicAction(this.props.Auth.HCID);
  //       } else if (this.state.isJobDetails == 2) {
  //         this.props.getContactAction(this.props.Auth.HCID);
  //       } else if (this.state.isJobDetails == 3) {
  //         this.props.getEducationAction(this.props.Auth.HCID);
  //       } else if (this.state.isJobDetails == 4) {
  //         this.props.getEmployeeAction(this.props.Auth.HCID);
  //       }
  //       else if(this.state.isJobDetails==4){
  //         // this.props.getlanguageAction(this.props.Auth.HCID);
  //       }
  //     }
  //   }
  // }
  async applyJob() {
    this.props.setLoader(true);
    var object = this.props.previewjob.Data[0];

    var obj = {
      CandidateNo: this.props.Auth.HCID,
      JobID: object.JobNumber,
    };
    var objs = {
      jobId: object.f_jobId,
      jobCode: object.JobNumber,
      mgApplicantId: this.props.Auth.MGID,
      hcApplicantId: this.props.Auth.HCID,
    };
    let response = await this.props.jobApplyAction(obj);
    if (response.ResponseCode == 100) {
      await this.props.saveAppliedJobsHc(objs);
      this.setState({ IsJobApllied: true });
      alert(response.Data);
      this.props.setLoader(false);
      window.location.reload();
    } else {
      this.setState({ IsJobApllied: false });
      window.location.reload();
      alert(response.ResponseMessage);
      this.props.setLoader(false);
    }
  }
  render() {
    let everAppliedForJob = this.props.ApplicationSummary
      ? this.props.ApplicationSummary.Data
        ? this.props.ApplicationSummary.Data.JobsData
          ? this.props.ApplicationSummary.Data.JobsData.length > 0
          : ""
        : ""
      : "";
    return (
      <Modal
        center
        open={this.props.showApply}
        onClose={this.props.handler}
        classNames={{
          modal: "popup-1000per",
        }}
      >
        <div className="lg:px-4 md:px-4">
          {this.state.isJobDetails === 0 && (
            <div className="refer-modal p-0">
              <div className=" lg:px-4 md:px-4 px-0 md:py-2 lg:py-2 py-0">
                <h1 className="fsize20 font-semibold text-black text-center">
                  Disclaimer
                </h1>

                <p className="fsize16 text-black lg:mt-8 md:mt-8 mt-4 text-left line-height2">
                  {everAppliedForJob && false ? (
                    "Profile is successfully completed!"
                  ) : (
                    <ul className="pl-4">
                      <li className="pt-1">
                        I, hereby certify that the details that I am to provide
                        are true and correct to the best of my knowledge.
                      </li>
                      <li className="pt-1">
                        I understand, if any of the information is found to be
                        false or untrue, misleading, or misrepresented, I am
                        aware that I am liable for it. If anything is found
                        contrary to the details provided, ICICI Bank Ltd. shall
                        have the sole discretion in regards to admission to the
                        programme and further employment, as the case may be.
                      </li>
                      <li className="pt-1">
                        I authorize ICICI Bank Ltd. to request & receive
                        relevant information necessary for the admissibility to
                        the programme.
                      </li>
                      <li className="pt-1">
                        I have read & understood the eligibility criteria of the
                        programme.
                      </li>
                    </ul>
                  )}
                </p>

                <div className="md:mt-12 lg:mt-12 mt-4 inline-grid w-full">
                  <button
                    className="mb-2 mx-auto rounded-full outline-button btn-disclaimer"
                    onClick={() =>
                      this.setState({
                        isJobDetails: 1,
                      })
                    }
                  >
                    {everAppliedForJob && false
                      ? "EDIT APPLICATION"
                      : "I AGREE"}
                  </button>
                  {everAppliedForJob && false ? (
                    <button
                      className="filled-button rounded-full font-semibold fsize16  w-200px h-50px"
                      onClick={() => this.applyJob()}
                    >
                      APPLY DIRECTLY
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          )}

          {this.state.isJobDetails > 0 && this.state.isJobDetails < 6 && (
            <div className="px-4  flex-auto">
              <div className="flex justify-center">
                <div className="relative pt-1 lg:w-1/3 md:w-1/3 w-3/4">
                  <p className="fsize14 font-semibold mb-3 text-center">
                    Step {this.state.isJobDetails}/3
                    <span className="font-normal ml-3 text-black">
                      To complete your profile
                    </span>
                  </p>
                  <div className="overflow-hidden h-1 mb-4 text-xs flex rounded bgFAE5D3-transparent">
                    <div
                      style={{
                        width: this.state.isJobDetails * 33.33 + "%",
                        background: "#E87F22",
                      }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap  text-white justify-center bg-amber-500"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.isJobDetails === 1 && (
            <div className="refer-modal  p-0">
              <h2 className="fsize20 font-bold mb-3">Add Resume</h2>
              <Resume />

              <div>
                <div className="md:mt-4 lg:mt-4 mt-1 flex justify-end">
                  {/* <button
                    className="fsize16 font-semibold mr-6 rounded-full  outline-button w-200px h-50px"
                    onClick={() =>
                      this.setState({
                        isJobDetails: 0,
                      })
                    }
                  >
                    SKIP
                  </button> */}
                  <button
                    className={
                      (!this.props.Auth.HCID ? "opacity-50 " : "") +
                      "btn btn-filled btn-width-sm"
                    }
                    onClick={() =>
                      this.setState({
                        isJobDetails: 2,
                      })
                    }
                    disabled={!this.props.Auth.HCID}
                  >
                    NEXT
                  </button>
                </div>
              </div>
            </div>
          )}

          {this.state.isJobDetails === 2 && (
            <div className="refer-modal  p-0">
              <h2 className="fsize20 font-bold mb-3">Contact Details</h2>
              <div className="lg:flex md:flex lg:w-full md:w-full">
                {/* <div className="lg:w-1/2 md:w-1/2 w-full lg:pr-8 md:pr-8 lg:mb-0 mb-4">
                  <img src={pdfview} />
                </div> */}
                <Contact />
              </div>

              <div>
                <div className="md:mt-6 lg:mt-6 mt-4 flex justify-end ">
                  <button
                    className="mr-6 btn-outline btn-width-sm"
                    onClick={() =>
                      this.setState({
                        isJobDetails: 1,
                      })
                    }
                  >
                    BACK
                  </button>
                  <button
                    className={
                      (this.props.userWalkthrough.CONTACTDETAILS === ""
                        ? "opacity-50 "
                        : "") + "btn btn-filled mr-2 btn-width-sm"
                    }
                    onClick={() =>
                      this.setState({
                        isJobDetails: 3,
                      })
                    }
                    disabled={this.props.userWalkthrough.CONTACTDETAILS === ""}
                  >
                    NEXT
                  </button>
                </div>
              </div>
            </div>
          )}
          {this.state.isJobDetails === 3 && (
            <div className="refer-modal  p-0">
              <h2 className="fsize20 font-bold mb-3">Education Details</h2>
              <div className="lg:flex md:flex">
                <Education Next={this.checkSubmit.bind(this)} />
                {/* <div className="lg:w-1/2 md:w-1/2 w-full lg:pr-8 md:pr-8 lg:mb-0 mb-4">
                  <img src={pdfview} />
                </div> */}
                {/* <form
                  action=""
                  className="lg:w-1/2 md:w-1/2 w-full lg:pl-8 md:pl-8"
                >
                  <div className="">
                    <div class="form-group  modal-form-cs">
                      <label for="">Select Eduction</label>
                      <select className="select-dropdown-c fsize15">
                        <option value="board">Class X </option>
                        <option value="board">Class X1</option>
                      </select>
                    </div>

                    <div class="form-group pt-4 modal-form-cs">
                      <label for="">Name of Board</label>
                      <select className="select-dropdown-c fsize15">
                        <option value="board">10 </option>
                        <option value="board">20</option>
                      </select>
                    </div>
                    <div class="form-group pt-4 modal-form-cs">
                      <label for="">Grade/Percentage</label>
                      <input type="text" placeholder="" value="8.0" />
                    </div>
                    <div className="flex items-center pt-4">
                      <div class="form-group modal-form-cs pr-3 w-1/2">
                        <label for="">Month of Passing</label>
                        <select className="select-dropdown-c fsize15">
                          <option value="Male">June </option>
                          <option value="Female">July</option>
                        </select>
                      </div>
                      <div class="form-group modal-form-cs pl-3 w-1/2">
                        <label for="">Year of Passing</label>
                        <input type="date" placeholder="" />
                      </div>
                    </div>
                    <p className="textE77817 text-right pt-6 font-semibold  uppercase fsize14">
                      ADD MORE EDUCATION +
                    </p>
                  </div>
                </form>
             */}
              </div>
              {this.state.isSubmit == true ||
              this.props.userWalkthrough.EDUCATIONDETAILS == "" ? (
                <div>
                  <div className="md:mt-6 lg:mt-6 mt-4 flex justify-end ">
                    <button
                      className="mr-6 btn-outline btn-width-sm"
                      onClick={() =>
                        this.setState({
                          isJobDetails: 2,
                        })
                      }
                    >
                      BACK
                    </button>
                    <button
                      className={"opacity-50 btn-filled btn-width-sm"}
                      onClick={() =>
                        this.setState({
                          isJobDetails: 6,
                        })
                      }
                      disabled={
                        this.state.isSubmit == true ||
                        this.props.userWalkthrough.EDUCATIONDETAILS == ""
                      }
                    >
                      NEXT
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="md:mt-8 lg:mt-8 mt-4 flex justify-end ">
                    <button
                      className="mr-4 btn-outline"
                      onClick={() =>
                        this.setState({
                          isJobDetails: 2,
                        })
                      }
                    >
                      BACK
                    </button>
                    <button
                      className={"ml-4 btn-filled btn-width-sm"}
                      onClick={() =>
                        this.setState({
                          isJobDetails: 6,
                        })
                      }
                      //  disabled={}
                    >
                      NEXT
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
          {/* 
          {this.state.isJobDetails === 4 && (
            <div className="refer-modal  p-0">
              <h2 className="fsize20 font-bold mb-3">Add Experience</h2>
              <div className="lg:flex md:flex"> */}
          {/* <Experience /> */}
          {/* <div className="mb-8">
                    <img src={pdfview} />
                  </div> */}

          {/* <div>
                    <div class="form-group  modal-form-cs">
                      <label for="">Role 01</label>
                      <select className="select-dropdown-c fsize15">
                        <option value="board">Risk Analyst</option>
                        <option value="board">Risk Analyst</option>
                      </select>
                    </div>

                    <div class="form-group pt-4 modal-form-cs">
                      <label for="">Role 02</label>
                      <select className="select-dropdown-c fsize15">
                        <option value="board">Project Manager</option>
                        <option value="board">Project Manager</option>
                      </select>
                    </div>
                    <div class="form-group  lg:pt-12 md:pt-12 pt-4 modal-form-cs">
                      <label for="">Description</label>
                      <input
                        type="text"
                        placeholder=""
                        className="h-79px pb-12 fsize16"
                        value="Type Description.."
                      />
                    </div>
                  </div> */}
          {/* </div> */}
          {/* 
              <div>
                <div className="mt-8 flex justify-end ">
                  <button
                    className="fsize16 font-semibold mr-8 rounded-full  outline-button w-200px h-50px"
                    onClick={() =>
                      this.setState({
                        isJobDetails: 3,
                      })
                    }
                  >
                    BACK
                  </button>
                  <button
                    className="filled-button rounded-full font-semibold fsize16  w-200px h-50px"
                    onClick={() =>
                      this.setState({
                        isJobDetails: 5,
                      })
                    }
                  >
                    NEXT
                  </button>
                </div>
              </div>
            </div>
          )} */}

          {/* {this.state.isJobDetails === 5 && (
            <div className="refer-modal  p-0">
              <h2 className="fsize20 font-bold mb-3">Add Miscellaneous</h2>
              <div className="lg:flex md:flex">
                <Miscellaneous />
              </div>
              <div>
                <div className="mt-8  flex justify-end ">
                  <button
                    className="fsize16 font-semibold mr-8 rounded-full  outline-button w-200px h-50px"
                    onClick={() =>
                      this.setState({
                        isJobDetails: 4,
                      })
                    }
                  >
                    BACK
                  </button>
                  <button
                    className="filled-button rounded-full font-semibold fsize16  w-200px h-50px"
                    onClick={() => {
                      this.setState({
                        isJobDetails: 6,
                      });
                    }}
                  >
                    NEXT
                  </button>
                </div>
              </div>
            </div>
          )} */}
          {this.state.isJobDetails === 6 && (
            <div className="refer-modal  p-0">
              <div className="text-center pt-12 pb-6 ">
                <img src={checksuccess} className="m-auto" />
                <h1 className="fsize18 text-center font-bold line-h25 md:mt-8 lg:mt-8 mt-6">
                  Success!
                </h1>
                {/* <br /> */}
                <p className="fsize16 text-black pt-2">
                  Your profile is completed now, please click on Apply
                </p>
                <div class="w-full fixed-btn md:mt-8 lg:mt-8 mt-6">
                  <button
                    className="btn-filled btn-width-sm"
                    onClick={() => this.applyJob()}
                  >
                    {this.state.IsJobApllied ? "Applied" : "Apply"}
                  </button>
                </div>
                <br />
                <b className="fsize16 text-black pt-2">
                  {" "}
                  Post Submitting your application{" "}
                </b>
              </div>
              <div className="text-center">
                <b className="fsize16 text-black pt-2 text-center">
                  1. You will receive an email for Online Test from
                  icicicareers@icicibank.com
                </b>
                <br />
                <b className="fsize16 text-black pt-2 text-center">
                  2. Please attempt the test within 4 days of receipt of the
                  email
                </b>
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
    ApplicationSummary: state.SingleJob.home.APPLICATIONSUMMARY,
    previewjob: state.SingleJob.home.CURRENTJOB,
    userWalkthrough: state.userWalkthrough.info,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBasicAction: async (payload) => await dispatch(getBasicAction(payload)),
    // getSingleApplicantInfoAction: async (payload) => {await dispatch(getSingleApplicantInfoAction(payload))},
    setLoader: async (flag) => await dispatch(setLoader(flag)),
    getContactAction: async (payload) =>
      await dispatch(getContactAction(payload)),
    getEducationAction: async (payload) =>
      await dispatch(getEducationAction(payload)),
    getEmployeeAction: async (payload) =>
      await dispatch(getEmployeeAction(payload)),
    getlanguageAction: async (payload) =>
      await dispatch(getlanguageAction(payload)),
    jobApplyAction: async (payload) => await dispatch(jobApplyAction(payload)),
    saveAppliedJobsHc: async (payload) =>
      await dispatch(saveAppliedJobsHc(payload)),
    geResumeHC: async (payload) => await dispatch(geResumeHC(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobDetailsApplyPopup);
